/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_EmergencyInputs */

const en_home_footer_link_emergency = /** @type {(inputs: Home_Footer_Link_EmergencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emergency Line`)
};

const fr_home_footer_link_emergency = /** @type {(inputs: Home_Footer_Link_EmergencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligne d'urgence`)
};

/**
* | output |
* | --- |
* | "Emergency Line" |
*
* @param {Home_Footer_Link_EmergencyInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_emergency = /** @type {((inputs?: Home_Footer_Link_EmergencyInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_EmergencyInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_emergency(inputs)
	return fr_home_footer_link_emergency(inputs)
});